import { TableHeader } from "app/components/Table/types";
import { ICustomizeColumns } from "app/types";
import { GroupByTypeEnum } from "../../../../types";
import { TICKET_HEADERS } from "./data";

function defaultWidthMinMax(field: ICustomizeColumns) {
  const isName = field.type === GroupByTypeEnum.TICKET_NAME;
  return {
    width: isName ? 747 : 250,
    min: isName ? 300 : 150,
    max: isName ? 747 : 450,
  };
}

export function getUpdatedColumns(data: ICustomizeColumns[]) {
  return data
    ?.filter((field) => {
      if (field.type === GroupByTypeEnum.TICKET_NAME) return true;
      if (
        field.type === GroupByTypeEnum.TAGS ||
        field.type === GroupByTypeEnum.TICKET_ID
      )
        return false;
      return !field.disabled && field.isVisible;
    })
    .map((field) => {
      const existingColumn = TICKET_HEADERS.find(
        (col) => col.name === field.fieldName,
      );
      const defaults = defaultWidthMinMax(field);

      if (existingColumn) {
        return {
          ...existingColumn,
          width: field.width ?? existingColumn.width,
          min: field.min ?? existingColumn.min,
          max: field.max ?? existingColumn.max,
          order: field.order,
        };
      }

      return {
        name:
          field.type === GroupByTypeEnum.TICKET_NAME
            ? "Name"
            : field.fieldName,
        id: field.type,
        resizable: true,
        sortable: true,
        className: "!p-[4px] text-xs leading-[18px] font-medium",
        width: field.width ?? defaults.width,
        min: field.min ?? defaults.min,
        max: field.max ?? defaults.max,
        order: field.order,
      };
    });
}

export function mergeListColumnWidthsIntoCustomizeCards(
  customizeCards: ICustomizeColumns[],
  cols: TableHeader[],
): ICustomizeColumns[] {
  const sizes: Partial<
    Record<GroupByTypeEnum, { width: number; min: number; max: number }>
  > = {};

  for (const col of cols) {
    if (col.resizable === false) continue;
    const id = String(col.id);
    if (!id) continue;
    const key =
      id === "name" ? GroupByTypeEnum.TICKET_NAME : (id as GroupByTypeEnum);
    sizes[key] = {
      width: Number(col.width),
      min: Number(col.min),
      max: Number(col.max),
    };
  }

  return customizeCards.map((card) => {
    const s = sizes[card.type];
    return s ? { ...card, ...s } : card;
  });
}
